/**
 * @fileoverview POST handler for the "/alloys/zendesk-sunshine/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { postAlloysZendeskSunshineAppGroupIdCacheKeys } from "./constants";
import type {
  PostAlloysZendeskSunshineAppGroupIdProps,
  PostAlloysZendeskSunshineAppGroupIdResult,
  PostAlloysZendeskSunshineErrors,
} from "./types";

export const postAlloysZendeskSunshineAppGroupId = reactQueryMutationAdapter(
  postAlloysZendeskSunshineAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAlloysZendeskSunshineErrors>()(
    (props: PostAlloysZendeskSunshineAppGroupIdProps): Promise<PostAlloysZendeskSunshineAppGroupIdResult> => {
      return fetch(
        `/alloys/zendesk-sunshine/${props.appGroupId}`,
        "POST",
        {
          subdomain: props.subdomain,
          sunshine_app_id: props.sunshineAppId,
          key_id: props.keyId,
          key_secret: props.keySecret,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
